function FooterStyle({ children }) {
  return (
    <footer className="footer w-full footer-center p-4 mt-4 bg-neutral text-neutral-content font-thin">
      {children}
    </footer>
  );
}

export default FooterStyle;
